import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpService } from '../http.service';
import * as Constants from '@emi/shared/constants';
import { SkuSearchDto, SkuSearchRequest } from '@emi/shared/models';

@Injectable({
  providedIn: 'root'
})
export class SkuSearchService {

  public notifyNewSearchSubject = new BehaviorSubject<boolean>(false);

  public updateSearchFilterText(value: boolean) {
    this.notifyNewSearchSubject.next(value)
  }
  constructor(private httpService: HttpService) { }

  public getSkus(request: SkuSearchRequest): Observable<SkuSearchDto> {
    return this.httpService.postHttp<SkuSearchDto>(Constants.ServiceConstants.SKU_SEARCH, request);
  }
}
